import { Modal } from 'react-bootstrap';
import { FileUpload } from 'primereact/fileupload';
// import allImages from '../../../../assets/images/allImages';
import Form from 'react-bootstrap/Form';
import lang from '../../../../assets/i18n/en.json';
import { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import { REGEX_PATTERN_URL } from '../../../../utils/global';
import { BasicPopup } from '../../../Common/basicPopup/BasicPopup';
// import { Button } from 'primereact/button';
import { toast } from 'react-toastify';
import { toastResponse } from '../../../../helper components/Toast/Toast';
import { CreateClientAddress, CreateEnterpriseClient, UpdateClient, UpsertClientLogoImage } from '../../../../Mutations/MutationsUpdated';
import { random } from 'lodash';
// import { useNavigate } from 'react-router';
// import { useDispatch } from 'react-redux';

export const AddEnterprise = (props) => {
  const PAGE = lang.PAGE;
  const ERROR = lang.ERROR;
  // const navigate = useNavigate();
  // const dispatch = useDispatch();
  // const client = useApolloClient();
  const [showBasicPopup, setShowBasicPopup] = useState(false);
  const [checkExistingLogo, setCheckExistingLogo] = useState(false);
  const [showImgUploadError, setShowImgUploadError] = useState(false);
  const [popupEnterpriseDetails, setPopupEnterpriseDetails] = useState({});
  const [selectedLogoFile, setSelectedLogoFile] = useState({});
  const [basicLogoInfo, setBasicLogoInfo] = useState({});
  const [newEnterpriseID, setNewEnterpriseID] = useState();

  const chooseOptions = {
    icon: 'pi pi-fw pi-images',
    iconOnly: true,
    className: 'custom-choose-btn p-button-rounded p-button-outlined',
  };
  const [errors, setError] = useState({
    enterprisename: false,
    enterprisenameError: '',
    websiteurl: false,
    websiteurlError: '',
    address1: false,
    address1Error: '',
    address2: false,
    address2Error: '',
  });
  const [enterpriseDetails, setEnterpriseDetails] = useState({
    enterpriseLogo: '',
    enterpriseLogoPresignedURL: '',
    // enterpriseLogoId: '',
    enterprisename: '',
    websiteurl: '',
    address1: '',
    address2: '',
    enterpriseId: ''
  });


  //Assign mutaions to variable
  const [upsertEnterpriseLogo] = useMutation(UpsertClientLogoImage, {
    onCompleted: async (data) => {
      setBasicLogoInfo(data.upsertClientLogoImage);

      if (selectedLogoFile) {
        const presignedURL = data.upsertClientLogoImage.presignedURL;

        try {
          // Use the fetch API to upload the image to the pre-signed URL
          await fetch(presignedURL, {
            method: 'PUT',
            body: selectedLogoFile,
            // body: enterpriseDetails.enterpriseLogo,
            headers: {
              'Content-Type': selectedLogoFile.type,
            },
          });
        } catch (error) {
          console.error('Error uploading image:', error);
        }
      }
    },

    onError: ({ graphQLErrors }) => {
      if (graphQLErrors) {
        if (graphQLErrors[0].extensions.response) {
          if (
            graphQLErrors[0].extensions.response.statusText === 'Unauthorized'
          )
            // Check if any of the GraphQL errors have a 401 status code
            toast.error(
              toastResponse(
                'error',
                ERROR.CUSTOM.CODE.ERROR_USER_ROLE_NOT_EXIST,
              ),
            );
        } else {
          toast.error(toastResponse('error', graphQLErrors[0].message));
        }
      }
    },
  });

  const [createEnterpriseAddress] = useMutation(CreateClientAddress, {
    onCompleted: async (data) => {
      // setNewEnterpriseID(data?.createEnterpriseClient);

      // setShowBasicPopup(true);
      // props.onHide();
      // isLoginResponse(data);
    },

    onError: ({ graphQLErrors }) => {
      toast.error(toastResponse('error', graphQLErrors[0].message));
      // if (graphQLErrors[0].extensions.response.statusText === "Unauthorized") {
      //     // Check if any of the GraphQL errors have a 401 status code
      //     toast.error(toastResponse('error', ERROR.CUSTOM.CODE.ERROR_USER_ROLE_NOT_EXIST));
      // }
    },
  });

  //Assign mutaions to variable
  const [createEnterprise, { loading }] = useMutation(CreateEnterpriseClient, {
    onCompleted: async (data) => {
      setNewEnterpriseID(data?.createEnterpriseClient);
      const input =  {
        clientId: data?.createEnterpriseClient,
        addressLine: enterpriseDetails.address1,
        addressLine2: enterpriseDetails.address2,
        state: 'OR'
      } 
      await upsertEnterpriseLogo({ variables: { clientId: data?.createEnterpriseClient } });
      await createEnterpriseAddress({ variables: { input: input } });
      setShowBasicPopup(true);
      props.onHide();
      // isLoginResponse(data);
    },

    onError: ({ graphQLErrors }) => {
      toast.error(toastResponse('error', graphQLErrors[0].message));
      // if (graphQLErrors[0].extensions.response.statusText === "Unauthorized") {
      //     // Check if any of the GraphQL errors have a 401 status code
      //     toast.error(toastResponse('error', ERROR.CUSTOM.CODE.ERROR_USER_ROLE_NOT_EXIST));
      // }
    },
  });

  //Assign mutaions to variable
  const [updateEnterprise, { updateEnterpriseloading }] =
    useMutation(UpdateClient, {
      onCompleted: async (data) => {
        console.log(data.updateEnterprise);        
        // isLoginResponse(data);
        console.log('updateEnterprise', enterpriseDetails)
      },

      onError: ({ graphQLErrors }) => {
        toast.error(toastResponse('error', graphQLErrors[0].message));
      },
    });

  const fnCreateEnterprise = async () => {
    // setShowBasicPopup(true);
    console.log('click update', enterpriseDetails)
    setPopupEnterpriseDetails(enterpriseDetails);
    props.onHide();

    const input = {
      // accentColor: '#ebe134',
      // address1: enterpriseDetails.address1,
      // address2: enterpriseDetails.address2,
      name: enterpriseDetails.enterprisename,
      // primaryColor: '#eb3434',
      // secondaryColor: '#8034eb',
      url: enterpriseDetails.websiteurl,
      // logoId: basicLogoInfo.id,
      // entityType: "PARTNERSHIP",
      taxId: Math.random().toString(36).substr(2, 9),
      products: "ENTERPRISE_PORTAL"
    };

    //Clear basic enterprise logo info
    setBasicLogoInfo({});
    // setSelectedLogoFile({});
    console.log('update')

    try {
      //Call mutaion with parameter
      if (props.selectedRow) {
        await updateEnterprise({
          variables: {
            input: {
              name: input.name,
              url: input.url,
              // address1: input.address1,
              // address2: input.address2,
              // primaryColor: input.primaryColor,
              // secondaryColor: input.secondaryColor,
              // accentColor: input.accentColor,
            },
            updateClientId: props.selectedRow.id,
          },
        });
        const inputAddress =  {
          clientId: props.selectedRow.id,
          addressLine: enterpriseDetails.address1,
          addressLine2: enterpriseDetails.address2,
          state: 'OR'
        } 
        if (selectedLogoFile && !checkExistingLogo) {
          await upsertEnterpriseLogo({ variables: { clientId: props.selectedRow.id } });
        }
        await createEnterpriseAddress({ variables: { input: inputAddress } });
        setShowBasicPopup(true);
        props.onHide();
      } else {
        createEnterprise({ variables: { input: input } });
      }
    } catch (error) {
      toast.error(toastResponse('error', error));
    }
  };

  // console.log(selectedLogoFile)
  const headerTemplate = (options) => {
    return (
      <>
        <div
          className="text-center p-0 position-relative"
          style={{ backgroundColor: 'transparent' }}
        >
          <img
            src={enterpriseDetails.enterpriseLogoPresignedURL}
            style={{
              height: '3rem',
              display: enterpriseDetails.enterpriseLogoPresignedURL
                ? 'inline-block'
                : 'none',
              position: 'absolute',
              cursor: 'pointer',
            }}
            alt="enterpriseLogo"
          />
          <span
            className={`${enterpriseDetails.enterpriseLogoPresignedURL ? 'opacity-0' : 'opacity-100'}`}
          >
            {options.chooseButton}
          </span>

          <FileUpload
            name="demo[]"
            url="/api/upload"
            className={`${enterpriseDetails.enterpriseLogoPresignedURL ? 'd-none fileUploadLink' : 'fileUploadLink'}`}
            accept="image/*"
            maxFileSize={1000000}
            chooseLabel="Add Logo"
            disabled={selectedLogoFile.length > 0}
            onUpload={onTemplateUpload}
            onSelect={onTemplateSelect}
            onError={onTemplateClear}
            onClear={onTemplateClear}
          />
        </div>

        {/* <div className="text-center p-0 pt-3" style={{ display: props.selectedRow && !removeExistingLogo ? 'block' : 'none' }}>
                    <span>{props.selectedRow ? props.selectedRow.logo : ''}</span> <Button type="button" icon="pi pi-times" className="p-button-outlined p-button-rounded p-button-danger ml-auto"
                        style={{ height: '1rem', width: '1.5rem', verticalAlign: 'middle' }} onClick={() => setRemoveExistingLogo(true)} />
                </div> */}
      </>
    );
  };

  const onTemplateSelect = (e) => {
    // setRemoveExistingLogo(true);
    setEnterpriseDetails((enterpriseDetails) => ({
      ...enterpriseDetails,
      enterpriseLogo: e?.files[0]?.objectURL,
    }));
    if (e?.files[0]?.type.includes('image')) {
      setShowImgUploadError(false);
      // if (selectedLogoFile.length < 1) {
      setSelectedLogoFile(e?.files[0]);
      setCheckExistingLogo(false)
      // }
    } else {
      setShowImgUploadError(true);
    }

    //Call mutaion with parameter
    // if (Object.keys(basicLogoInfo).length === 0) {
      // upsertEnterpriseLogo({
      //   variables: {
      //     input: {
      //       clientId: enterpriseDetails.enterpriseId,
      //     }
      //   },
      // });
    // }
  };

  const onTemplateUpload = (e) => {
    // let _totalSize = 0;
    // e.files.forEach((file) => {
    //     _totalSize += file.size || 0;
    // });
    // setTotalSize(_totalSize);
    // toast.current.show({ severity: 'info', summary: 'Success', detail: 'File Uploaded' });
  };

  // const onTemplateRemove = (file, callback) => {
  //   // setTotalSize(totalSize - file.size);
  //   callback();
  // };

  const onTemplateClear = () => {
    // setTotalSize(0);
  };

  useEffect(() => {
    if(props?.selectedRow) 
    setEnterpriseDetails({
      enterpriseLogoPresignedURL: props.selectedRow
        ? props.selectedRow.logo?.presignedURL
        : '',
      enterprisename: props.selectedRow ? props.selectedRow.name : '',
      // enterpriseLogoId: props.selectedRow
      //   ? props.selectedRow.logo?.id
      //   : null,
      enterpriseId: props.selectedRow.id,
      websiteurl: props.selectedRow ? props.selectedRow.url : '',
      address1: props.selectedRow.addresses.length > 0 ? props.selectedRow.addresses[0].addressLine : '',
      address2: props.selectedRow.addresses.length > 0 ? props.selectedRow.addresses[0].addressLine : '',
    });

    setError({
      enterprisename: false,
      enterprisenameError: '',
      websiteurl: false,
      websiteurlError: '',
      address1: false,
      address1Error: '',
      address2: false,
      address2Error: '',
    });
    setCheckExistingLogo(true)
    // setRemoveExistingLogo(false);
  }, [props]);

  return (
    <>
      <Modal
        show={props.show}
        onHide={() => {
          props.onHide();
          setBasicLogoInfo({});
          setSelectedLogoFile({});
        }}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header
          closeButton
          className="modal-header px-8 pt-8 pb-4"
          style={{
            borderBottom: '#fff',
            margin: '0%',
            alignItems: 'flex-start',
          }}
        >
          <Modal.Title>
            <div className="fw-bolder">
              {' '}
              {props.selectedRow ? 'Edit Enterprise' : 'Create Enterprise'}
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-8 py-0 modal-body send-invitation-model">
          {/* <FileUpload mode="basic" name="demo[]" url="/api/upload" accept="image/*" maxFileSize={1000000} chooseOptions={chooseOptions} /> */}
          <FileUpload
            name="demo[]"
            url="/api/upload"
            accept="image/*"
            maxFileSize={1000000}
            disabled={selectedLogoFile.length > 0}
            onUpload={onTemplateUpload}
            onSelect={onTemplateSelect}
            onError={onTemplateClear}
            onClear={onTemplateClear}
            headerTemplate={headerTemplate}
            chooseOptions={chooseOptions}
          />

          {/* <FileUpload mode="basic" name="demo[]" url="/api/upload" accept="image/*" maxFileSize={1000000} auto chooseLabel='Add Logo'
                        onUpload={onTemplateUpload} onSelect={onTemplateSelect} onError={onTemplateClear} onClear={onTemplateClear} /> */}
          <div
            className="text-center"
            style={{
              display: showImgUploadError ? 'block' : 'none',
              color: 'red',
            }}
          >
            Please upload image only....
          </div>

          <div
            className="text-center p-0 pt-3"
            style={{ display: showImgUploadError ? 'none' : 'block' }}
          >
            <span>{selectedLogoFile.name}</span>{' '}
            <span>
              <button
                className="btn btn-rounded-border"
                style={{
                  border: '1px solid red',
                  padding: '0rem 0.5rem',
                  borderRadius: '34px',
                  display:
                    Object.keys(selectedLogoFile).length === 0
                      ? 'none'
                      : 'inline-block',
                }}
                onClick={() => setSelectedLogoFile({})}
              >
                x
              </button>
            </span>
          </div>

          <form>
            <div className="mb-4">
              <Form.Label>
                {PAGE.ENTERPRISE.CREATE.ENTERPRISENAME.LABEL}
              </Form.Label>
              <Form.Control
                type="text"
                className="form-control form-control-lg form-control-solid fs-6"
                isInvalid={errors.enterprisenameError}
                value={enterpriseDetails.enterprisename}
                onChange={(e) => {
                  setError((errors) => ({
                    ...errors,
                    enterprisenameError:
                      e?.target?.value.length > 50
                        ? PAGE?.ENTERPRISE?.CREATE?.ENTERPRISENAME?.MAX_LENGTH
                        : e?.target?.value.length < 1
                          ? PAGE?.ENTERPRISE?.CREATE?.ENTERPRISENAME
                              ?.VALIDATION_ERROR
                          : '',
                  }));
                  setEnterpriseDetails((enterpriseDetails) => ({
                    ...enterpriseDetails,
                    enterprisename: e.target.value,
                  }));
                }}
              />
              <Form.Control.Feedback type="invalid">
                {errors.enterprisenameError}
              </Form.Control.Feedback>
            </div>
            <div className="mb-4">
              <Form.Label>{PAGE.ENTERPRISE.CREATE.WEBSITEURL.LABEL}</Form.Label>
              <Form.Control
                type="text"
                className="form-control form-control-lg form-control-solid fs-6"
                isInvalid={errors.websiteurlError}
                value={enterpriseDetails.websiteurl}
                onChange={(e) => {
                  setError((errors) => ({
                    ...errors,
                    websiteurlError: REGEX_PATTERN_URL().test(e.target.value)
                      ? ''
                      : REGEX_PATTERN_URL().test(e.target.value).length > 50
                        ? PAGE?.ENTERPRISE?.CREATE?.WEBSITEURL?.MAX_LENGTH
                        : PAGE?.ENTERPRISE?.CREATE?.WEBSITEURL
                            ?.VALIDATION_ERROR,
                  }));
                  setEnterpriseDetails((enterpriseDetails) => ({
                    ...enterpriseDetails,
                    websiteurl: e.target.value,
                  }));
                }}
              />
              <Form.Control.Feedback type="invalid">
                {errors.websiteurlError}
              </Form.Control.Feedback>
            </div>
            <div className="mb-4">
              <Form.Label>Address 1</Form.Label>
              <Form.Control
                type="text"
                className="form-control form-control-lg form-control-solid fs-6"
                isInvalid={errors.address1Error}
                value={enterpriseDetails.address1}
                onChange={(e) => {
                  setError((errors) => ({
                    ...errors,
                    address1Error:
                      e?.target?.value.length > 50
                        ? PAGE?.ENTERPRISE?.CREATE?.ADDRESS1?.MAX_LENGTH
                        : e?.target?.value.length < 1
                          ? PAGE?.ENTERPRISE?.CREATE?.ADDRESS1?.VALIDATION_ERROR
                          : '',
                  }));
                  setEnterpriseDetails((enterpriseDetails) => ({
                    ...enterpriseDetails,
                    address1: e.target.value,
                  }));
                }}
              />
              <Form.Control.Feedback type="invalid">
                {errors.address1Error}
              </Form.Control.Feedback>
            </div>
            <div className="mb-4">
              <Form.Label>Address 2</Form.Label>
              <Form.Control
                type="text"
                className="form-control form-control-lg form-control-solid fs-6"
                value={enterpriseDetails.address2}
                onChange={(e) =>
                  setEnterpriseDetails((enterpriseDetails) => ({
                    ...enterpriseDetails,
                    address2: e?.target?.value,
                  }))
                }
              />
              {/* <Form.Control.Feedback type="invalid"></Form.Control.Feedback> */}
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer
          className="pt-0 px-8 pb-8 modal-footer"
          style={{ borderTop: '#fff', margin: '0%' }}
        >
          {/* <div className='mb-6 text-end'> */}
          <button
            type="button"
            className="customTable m-0 action-btn btn btn-primary btn-hover-color"
            disabled={
              // Object.keys(selectedLogoFile).length === 0 ||
              !(
                enterpriseDetails.enterprisename &&
                enterpriseDetails.websiteurl &&
                enterpriseDetails.address1 && 
                !errors.websiteurlError
              ) 
              // || (props.selectedRow ? !checkExistingLogo : Object.keys(selectedLogoFile).length === 0)
              
            }
            onClick={fnCreateEnterprise}
          >
            {' '}
            {props.selectedRow ? 'Save Edits' : 'Create Enterprise'}{' '}
            {loading ||
              (updateEnterpriseloading && (
                <i
                  className="spinner-grow spinner-grow-sm ms-3"
                  role="status"
                />
              ))}
          </button>
          {/* </div> */}
        </Modal.Footer>
      </Modal>

      <BasicPopup
        show={showBasicPopup}
        onHide={() => setShowBasicPopup(false)}
        entityName={popupEnterpriseDetails.enterprisename}
        entityLogo={popupEnterpriseDetails.enterpriseLogoPresignedURL}
        entityID = {newEnterpriseID}
        popupTitle={
          props.selectedRow
            ? 'Enterprise Edits Saved Successfully'
            : 'Enterprise Created Successfully'
        }
        popupSubTitle={`${popupEnterpriseDetails.enterprisename} has been ${props.selectedRow ? 'edited' : 'created'} successfully...!`}
        otherButtonText={props.selectedRow ? '' : 'Invite Admin'}
        onConfirmStatus={() => props.refetch()}
      />
    </>
  );
};
